export const ANATOMY_V2_COMPACT_BREAKPOINT = 660

export const anatomyV2Compact = `@media (max-height: ${ANATOMY_V2_COMPACT_BREAKPOINT}px)`

export const ANATOMY_V2_COMPACT = {
  fontSize: {
    f32: '22px',
    f15: '13px',
  },
  lineHeight: {
    lh38: '26px',
    lh20: '16px',
  },
  spacing: {
    s50: '20px',
    s24: '6px',
  },
}
